import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const CardCover = (props) => {
    const { className, ...otherProps } = props;
    return <div {...otherProps} className={clsx("card-cover", className)} />;
};
CardCover.propTypes = {
    className: PropTypes.string,
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
};
CardCover.defaultProps = {
    component: "div",
};

export default CardCover;
